export function removalsFromArray (arr, indexesToBeDeleted) {
  for (let idx in indexesToBeDeleted) {
    arr.splice(idx, 1)
  }
}

export function insertsIntoArray (arr, indexObjToBeAdded) {
  // of lets you iterate over a value
  for (let newObj of indexObjToBeAdded) {
    arr.splice(newObj.index, 0, newObj.newObject)
  }
}



// WEBPACK FOOTER //
// ./src/utilities/collection.helper.js